import { render, staticRenderFns } from "./AppSelectList.vue?vue&type=template&id=0568ad27&scoped=true&"
import script from "./AppSelectList.vue?vue&type=script&lang=js&"
export * from "./AppSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568ad27",
  null
  
)

export default component.exports